import React, { PropTypes } from 'react';
import ImmutablePropTypes from 'react-immutable-proptypes';
import { FormattedMessage } from 'react-intl';
import ReactCSSTransitionGroup from 'react-addons-css-transition-group';

import BcReactComponent from '@bibliocommons/base-bc-react-component';
import ScreenReaderMessage from '@bibliocommons/base-screen-reader-message';
import { Ellipsis } from '@bibliocommons/base-icons';
import { Dropdown } from '@bibliocommons/base-dropdown';
import { TextButton, GhostButton } from '@bibliocommons/base-buttons';

import './BatchActionsToolbar.scss';

export default class BatchActionsToolbar extends BcReactComponent {
  componentWillUnmount() {
    this.props.handleClear();
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.globalMessaging) {
      if (this.props.selectedItems.size === 0 && nextProps.selectedItems.size > 0) {
        this.props.messagingActions.clearGlobalMessage();
      } else {
        this.props.handleClear();
      }
    }
  }

  renderDropdown() {
    const { selectedItems, totalItems, renderActionsMenu, actionIsLoading } = this.props;

    const renderDropdownButtonText = () => (
      <span>
        <span aria-hidden>
          <FormattedMessage id="batch_actions_edit_items" />
          <Ellipsis />
        </span>
        <ScreenReaderMessage>
          <FormattedMessage id="ada_label_batch_actions_edit_items" values={{ totalItems, count: selectedItems.size }} />
        </ScreenReaderMessage>
      </span>
    );

    return (
      <Dropdown
        dropup
        right
        disableMobile
        className="actions-dropdown"
        isLoading={actionIsLoading}
        ButtonTag={GhostButton}
        renderSelected={renderDropdownButtonText}>
        {renderActionsMenu(selectedItems)}
      </Dropdown>
    );
  }

  renderSummary() {
    const { selectedItems, handleClear } = this.props;

    return (
      <div className="actions-summary">
        <span aria-hidden>
          <FormattedMessage id="batch_actions_selected_count" values={{ count: selectedItems.size }} />
        </span>
        <TextButton className="clear-button" handleClick={handleClear}>
          <span aria-hidden>
            <FormattedMessage id="button_clear" />
          </span>
          <ScreenReaderMessage>
            <FormattedMessage id="ada_label_batch_actions_clear" />
          </ScreenReaderMessage>
        </TextButton>
      </div>
    );
  }

  renderToolbar() {
    if (this.props.selectedItems.size > 0 && !this.props.globalMessaging) {
      return (
        <div className="cp-batch-actions-toolbar">
          <div className="container toolbar-container">
            <div className="toolbar-content">
              {this.renderSummary()}
              {this.renderDropdown()}
            </div>
          </div>
        </div>
      );
    }

    return null;
  }

  render() {
    return (
      <ReactCSSTransitionGroup
        component="div"
        transitionName="slide-up"
        transitionEnterTimeout={250}
        transitionLeaveTimeout={100}>
        {this.renderToolbar()}
      </ReactCSSTransitionGroup>
    );
  }
}

BatchActionsToolbar.propTypes = {
  actionIsLoading: PropTypes.bool,
  totalItems: PropTypes.number.isRequired,
  selectedItems: ImmutablePropTypes.map.isRequired,
  handleClear: PropTypes.func.isRequired,
  renderActionsMenu: PropTypes.func.isRequired,
  globalMessaging: ImmutablePropTypes.map,
  messagingActions: PropTypes.objectOf(PropTypes.func).isRequired
};

BatchActionsToolbar.defaultProps = {
  actionIsLoading: false
};



// WEBPACK FOOTER //
// ./app/components/shared/BatchActions/BatchActionsToolbar/BatchActionsToolbar.jsx